const messages = {
  en: {
    listaPreciosVenta: {
      title: "Price lists management",
      menuTitle: "Price lists",
      subtitle: "Create, edit and delete sale price lists",
      creating: "Creating price list",
      editing: "Editing price list",
      deleting: "Deleting price list",
      labels: {
        nombre: "Name",
        isDefault: "Default",
        formula: "Formula",
        margenDefault: "Default margin (%)",
        tipoRedondeo: "Rounding (list override)",
        sinOverride: "No override (use product setting)",
        ninguno: "None",
        centavos: "Round cents up",
        multiplo_10: "Round up to multiple of 10",
        multiplo_100: "Round up to multiple of 100",
      },
      hints: {
        tipoRedondeo:
          "If left without override, each product uses its own rounding",
        formula:
          "Variables: precio_compra, descuento, iva, margen",
      },
    },
  },
  es: {
    listaPreciosVenta: {
      title: "Administración de Listas de precios",
      menuTitle: "Listas de precios",
      subtitle: "Crear, editar y borrar listas de precios de venta",
      creating: "Creando lista de precios",
      editing: "Editando lista de precios",
      deleting: "Eliminando lista de precios",
      labels: {
        nombre: "Nombre",
        isDefault: "Por defecto",
        formula: "Fórmula",
        margenDefault: "Margen default (%)",
        tipoRedondeo: "Redondeo (override de lista)",
        sinOverride: "Sin override (usar el del producto)",
        ninguno: "Ninguno",
        centavos: "Redondear centavos hacia arriba",
        multiplo_10: "Redondear al múltiplo de 10",
        multiplo_100: "Redondear al múltiplo de 100",
      },
      hints: {
        tipoRedondeo:
          "Si se deja sin override, cada producto usa su propio tipoRedondeo",
        formula:
          "Variables disponibles: precio_compra, descuento, iva, margen",
      },
    },
  },
  pt: {
    listaPreciosVenta: {
      title: "Administração de Listas de preços",
      menuTitle: "Listas de preços",
      subtitle: "Criar, editar e excluir listas de preços",
      creating: "Criando lista de preços",
      editing: "Editando lista de preços",
      deleting: "Excluindo lista de preços",
      labels: {
        nombre: "Nome",
        isDefault: "Padrão",
        formula: "Fórmula",
        margenDefault: "Margem padrão (%)",
        tipoRedondeo: "Arredondamento (override)",
        sinOverride: "Sem override (usar do produto)",
        ninguno: "Nenhum",
        centavos: "Arredondar centavos para cima",
        multiplo_10: "Arredondar para múltiplo de 10",
        multiplo_100: "Arredondar para múltiplo de 100",
      },
      hints: {
        tipoRedondeo:
          "Sem override, cada produto usa seu próprio arredondamento",
        formula:
          "Variáveis: precio_compra, descuento, iva, margen",
      },
    },
  },
};

export default messages;
